import { useEffect, useState } from 'react';

import { AuthProvider, authStatus, TokenModel, UserModel } from '@picsart/growth-rc/AuthContext';
import HttpService from '@picsart/rc/services/http';
import useDevice from '@picsart/rc/useDevice';

import MonetizationProviderWrapper from 'providers/MonetizationProviderWrapper';
import useLandingPropsStore from 'stores/landingPropsStore';
import usePageDataStore from 'stores/pageDataStore';
import { API_URL } from 'utils/endpoints';
import type AuthWrapperType from './types';

function AuthWrapper({
  children,
  storageDataUnits,
  monetizationRequired,
  pageType,
}: AuthWrapperType) {
  const [status, setStatus] = useState<authStatus>(authStatus.pending);
  const [user, setUser] = useState<UserModel | null>(null);
  const [tokenData, setTokenData] = useState<TokenModel>();
  const setDeviceProps = useLandingPropsStore(x => x.setDeviceProps);
  const { isMobile, isTablet } = useDevice();
  const setIsLoggedIn = usePageDataStore(x => x.setIsLoggedIn);

  useEffect(() => {
    setDeviceProps({
      device: isMobile ? 'phone' : 'desktop',
      pending: false,
      isMobile: isMobile || isTablet,
    });
  }, [isMobile, isTablet, setDeviceProps, user]);
  HttpService.setConfig({
    apiUrl: API_URL,
  });

  useEffect(() => {
    if (status === authStatus.resolved) {
      setIsLoggedIn(true);
    } else if (status === authStatus.failed) {
      setIsLoggedIn(false);
    }
  }, [setIsLoggedIn, status]);

  return (
    <AuthProvider
      onUserChange={setUser}
      status={status}
      onStatusChange={setStatus}
      user={user}
      onTokenChange={setTokenData}
      tokenData={tokenData}
      hideOneTap={isMobile}
    >
      <MonetizationProviderWrapper
        storageDataUnits={storageDataUnits}
        user={user}
        monetizationRequired={monetizationRequired}
        pageType={pageType}
      >
        {children}
      </MonetizationProviderWrapper>
    </AuthProvider>
  );
}

export default AuthWrapper;
